import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useTrackEvent } from "./useTrackEvent";

export const usePageTracking = (): void => {
  const location = useLocation();
  const { trackEvent } = useTrackEvent();
  const lastTrackedPath = useRef<string | null>(null);

  useEffect(() => {
    if (lastTrackedPath.current === location.pathname) return;
    lastTrackedPath.current = location.pathname;

    trackEvent("page_viewed", {
      page_path: location.pathname,
      page_search: location.search || null,
      page_hash: location.hash || null,
    });
  }, [location.pathname, trackEvent]);
};
